import { render, staticRenderFns } from "./SolarDg.vue?vue&type=template&id=56e73f56&scoped=true&"
import script from "./SolarDg.vue?vue&type=script&lang=js&"
export * from "./SolarDg.vue?vue&type=script&lang=js&"
import style0 from "./SolarDg.vue?vue&type=style&index=0&id=56e73f56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e73f56",
  null
  
)

export default component.exports